import React from 'react';
import { Link } from 'gatsby';

import { ArrowFull } from '../../../../../static/icons/arrowFull';
import { Row } from '../../../atoms/row/Row';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import colors from '../../../../../tailwind.colors';

const CategorySubLinks = ({ title, description, links, handleClick }) => (
  <div className="flex flex-1 flex-col items-center gap-2">
    {(title || description) && (
      <Stack className="justify-center">
        {title && (
          <Row className="items-center min-w-max mt-1">
            <Typography as="h3" fontVariant="h7" textAlign="left">
              {title}
            </Typography>
          </Row>
        )}
        {description && (
          <Typography
            fontVariant="md"
            textAlign="left"
            className="!text-customGray-700"
          >
            {description}
          </Typography>
        )}
      </Stack>
    )}
    <div className="flex flex-col gap-2">
      {links?.map((link) => (
        <Link
          key={link.name}
          to={link.url}
          onClick={() => handleClick(link.name)}
          className="flex items-center gap-2"
        >
          <Typography
            fontVariant="h8"
            textAlign="left"
            className="!text-customGray-700"
          >
            {link.name}
          </Typography>
          {link.count && (
            <Typography
              fontVariant="sm"
              textAlign="left"
              className="!text-customGray-500"
            >
              ({link.count})
            </Typography>
          )}
          <ArrowFull color={colors.primary[500]} direction="right" />
        </Link>
      ))}
    </div>
  </div>
);

export default CategorySubLinks;
